import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Skeleton } from 'primeng/skeleton';

@Component({
  selector: 'formly-skeleton-loader',
  template: `
    <div class="configurator-content-skeleton">
      <div class="top-content-skeleton">
        <div class="top-left-skeleton">
          <div class="pic-skeleton">
            <p-skeleton height="18.75rem"></p-skeleton>
          </div>
        </div>
        <div class="top-right-card">
          <div class="card-fields">
            <p-skeleton [style]="{ 'margin-bottom': '1rem' }" height="2rem"></p-skeleton>
            <p-skeleton [style]="{ 'margin-bottom': '1rem' }" height="2rem"></p-skeleton>
            <p-skeleton [style]="{ 'margin-bottom': '1rem' }" height="2rem"></p-skeleton>
            <p-skeleton [style]="{ 'margin-bottom': '1rem' }" height="2rem"></p-skeleton>
          </div>
        </div>
      </div>
      <div class="bottom-content-skeleton">
        <div class="bottom-card">
          <div class="bottom-fields">
            <div class="bottom-fields-left">
              <p-skeleton [style]="{ 'margin-bottom': '1rem' }" height="2rem"></p-skeleton>
              <p-skeleton [style]="{ 'margin-bottom': '1rem' }" height="2rem"></p-skeleton>
              <p-skeleton [style]="{ 'margin-bottom': '1rem' }" height="2rem"></p-skeleton>
              <p-skeleton [style]="{ 'margin-bottom': '1rem' }" height="2rem"></p-skeleton>
            </div>
            <div class="bottom-fields-right">
              <p-skeleton [style]="{ 'margin-bottom': '1rem' }" height="2rem"></p-skeleton>
              <p-skeleton [style]="{ 'margin-bottom': '1rem' }" height="2rem"></p-skeleton>
              <p-skeleton [style]="{ 'margin-bottom': '1rem' }" height="2rem"></p-skeleton>
              <p-skeleton [style]="{ 'margin-bottom': '1rem' }" height="2rem"></p-skeleton>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      .configurator-content-skeleton {
        display: flex;
        flex-direction: column;
        height: 100%;
      }

      .top-content-skeleton {
        display: flex;
        flex-direction: row;
        height: 50%;

        .top-left-skeleton {
          width: 50%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .pic-skeleton {
          width: 100%;
          display: flex;
          flex-direction: column;
          padding: 2rem;
        }
      }

      .top-right-card {
        width: 50%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        .card-fields {
          width: 100%;
          display: flex;
          flex-direction: column;
          gap: 1rem;
          padding: 2rem;
        }
      }

      .bottom-content-skeleton {
        height: 50%;
        display: flex;
        align-items: center;
        justify-content: center;

        .bottom-card {
          width: 100%;
          height: 90%;
          display: flex;
          align-items: center;
          justify-content: center;

          .bottom-fields {
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            .bottom-fields-left,
            .bottom-fields-right {
              width: 50%;
              display: flex;
              flex-direction: column;
              gap: 1rem;
              padding: 2rem;
            }
          }
        }
      }
    `,
  ],
  standalone: true,
  imports: [Skeleton],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlySkeletonLoaderComponent {}
